import { isEmpty } from 'lodash';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { t } from 'Src/i18n';
import { ICONS } from 'Components/utils/icon/icons';
import { useAppContext } from 'Context/ReactAppContext';
import {
  getAdditionalTransportsError,
  getIsLoadingAdditionalTransports,
} from 'Store/booking/booking.selector';
import { AsyncLoader } from 'Components/widgets/loading/async-loader/AsyncLoader';
import { Confirmation } from 'Components/widgets/confirmation/Confirmation';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { SliderHandler } from 'Components/frameworks/slider-handler/SliderHandler';
import { makeWidgetProps } from 'Src/types/widget-helpers';
import { AdditionalTransports } from './AdditionalTransports';
type Props = {
  proposal: Proposal;
  setSelectedTransport: (transportId: string) => void;
};
const TRANSPORT_COMPANIES_LOGOS = [
  {
    url: 'https://ns.clubmed.com/it/2018/be/transport/airfrance.png',
    alt: 'Air France',
  },
  {
    url: 'https://ns.clubmed.com/it/2018/be/transport/flyemirates.png',
    alt: 'Fly Emirates',
  },
  {
    url: 'https://ns.clubmed.com/it/2018/be/transport/aircaraibes.png',
    alt: 'Air Caraïbes',
  },
  {
    alt: 'Singapore Airlines',
    url: 'https://ns.clubmed.com/it/2018/be/transport/singaporeairlines.png',
  },
  {
    url: 'https://ns.clubmed.com/it/2018/be/transport/qatarairways.png',
    alt: 'Qatar Airways',
  },
];
// hardcoded for now, there wasn't a compelling enough argument why this should be dynamic
export const AdditionalTransportsWrapper = ({ proposal, setSelectedTransport }: Props) => {
  const appContext = useAppContext();
  const error = useSelector(getAdditionalTransportsError);
  const isLoading = useSelector(getIsLoadingAdditionalTransports);
  return (
    <div data-testid="AdditionalTransportsWrapper" className="relative z-1 h-full">
      {isLoading && (
        <Fragment>
          <AsyncLoader
            className="mt-[18vh]"
            icon={ICONS.STANDALONE_MAGNIFYING_GLASS}
            iconSize="3rem"
            label={t('booking.transport.additionalTransports.loaderLabel')}
            theme="labeled"
          />
          <div className="m-auto mt-30 w-200">
            <SliderHandler
              {...makeWidgetProps<React.ComponentProps<typeof SliderHandler>>({
                nbItemsToShow: TRANSPORT_COMPANIES_LOGOS.length,
                hasAutoplay: true,
                hasInfiniteScroll: true,
                hasLazyload: true,
                items: TRANSPORT_COMPANIES_LOGOS.map((medium) => (
                  <img alt={medium.alt} className="w-full" key={medium.url} src={medium.url} />
                )),
                children: ({ itemsNode }) => itemsNode,
              })}
            />
          </div>
        </Fragment>
      )}
      {!isLoading && isEmpty(error) && (
        <AdditionalTransports proposal={proposal} setSelectedTransport={setSelectedTransport} />
      )}
      {!isLoading && !isEmpty(error) && (
        <SiteContainer>
          <Confirmation
            status="error"
            text={t(
              `booking.${appContext.isCmta ? 'partners' : 'common.layer'}.unknownErrorDescription`,
            )}
            title={t('booking.common.layer.unknownErrorTitle')}
          />
        </SiteContainer>
      )}
    </div>
  );
};
